import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Typography } from 'antd';
import {
  TeamOutlined,
  LogoutOutlined,
  DashboardOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '@/store/auth';

const { Header, Sider, Content } = Layout;

const menuItems = [
  {
    key: '/tenants',
    icon: <TeamOutlined />,
    label: '租户管理',
  },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const profile = useAuthStore((s) => s.profile);
  const clear = useAuthStore((s) => s.clear);

  const handleLogout = () => {
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <Layout className="min-h-screen">
      <Sider theme="light" width={220} className="shadow-sm">
        <div className="flex items-center gap-2 px-5 py-4 border-b border-gray-100">
          <DashboardOutlined className="text-blue-500 text-lg" />
          <span className="font-bold text-base text-gray-800">平台管理</span>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname.startsWith('/tenants') ? '/tenants' : location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          className="border-none mt-2"
        />
      </Sider>

      <Layout>
        <Header className="flex items-center justify-end bg-white px-6 shadow-sm h-14 leading-[56px]">
          <Typography.Text className="mr-4 text-gray-600">
            {profile?.name}
          </Typography.Text>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            退出
          </Button>
        </Header>

        <Content className="p-6">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
